/* eslint-disable */
"use client";

import { useEffect, useState } from "react";
import { getPersonalizationEnabled, getPersonalizationEnabledFor } from "@/lib/personalization";
import { getAuthStatus } from "@/lib/auth";

export default function PersonalizedGate({ children }: { children: React.ReactNode }) {
  const [enabled, setEnabled] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentUserId, setCurrentUserId] = useState<string | null>(null);
  
  useEffect(() => {
    // 로그인 상태 확인
    getAuthStatus()
      .then((data) => {
        const loggedIn = !!(data?.ok && data?.user);
        setIsLoggedIn(loggedIn);
        setCurrentUserId(loggedIn ? String(data.user.id) : null);
        
        if (!loggedIn) {
          // 로그인하지 않은 경우 개인화 섹션 숨김
          setEnabled(false);
          return;
        }
        
        // 로그인한 경우에만 개인화 상태 확인(사용자별 우선)
        try { 
          const globalState = !!(window as any).__dw_personalize_active__;
          const localState = currentUserId ? getPersonalizationEnabledFor(currentUserId) : getPersonalizationEnabled();
          setEnabled(globalState && localState); 
        } catch { 
          setEnabled(false); 
        }
      })
      .catch(() => {
        setIsLoggedIn(false);
        setCurrentUserId(null);
        setEnabled(false);
      });
    
    const onToggle = (e: Event) => {
      try {
        const detail = (e as CustomEvent)?.detail;
        const localState = currentUserId ? getPersonalizationEnabledFor(currentUserId) : getPersonalizationEnabled();
        // 로그인 상태이면서 전역 이벤트 상태와 로컬스토리지 상태 모두 true일 때만 활성화
        setEnabled(isLoggedIn && !!detail && localState);
      } catch {}
    };
    
    const onAuthChange = (e: Event) => {
      try {
        const detail = (e as CustomEvent)?.detail;
        const newLoginState = !!detail?.isLoggedIn;
        setIsLoggedIn(newLoginState);
        
        if (!newLoginState) {
          // 로그아웃된 경우 개인화도 비활성화(표시만)
          setEnabled(false);
          setCurrentUserId(null);
        } else {
          // 로그인된 경우 개인화 상태 다시 확인
          const globalState = !!(window as any).__dw_personalize_active__;
          const localState = currentUserId ? getPersonalizationEnabledFor(currentUserId) : getPersonalizationEnabled();
          setEnabled(globalState && localState);
        }
      } catch {}
    };
    
    window.addEventListener('dw:personalize_toggle', onToggle as EventListener);
    window.addEventListener('dw:auth_change', onAuthChange as EventListener);
    return () => {
      window.removeEventListener('dw:personalize_toggle', onToggle as EventListener);
      window.removeEventListener('dw:auth_change', onAuthChange as EventListener);
    };
  }, [isLoggedIn, currentUserId]);
  
  // 로그인하지 않았거나 개인화가 비활성화된 경우 섹션 숨김
  if (!isLoggedIn || !enabled) return null;
  return <>{children}</>;
}


